import dayjs from 'dayjs';

/**
 * Format a UTC date string to local date display
 */
export function formatDate(dateString: string): string {
  return dayjs(dateString).format('MMM D, YYYY');
}

/**
 * Get the return URL for auth redirects
 */
export function getReturnUrl(): string {
  return window.location.pathname + window.location.search;
}

/**
 * Store return URL in session storage
 */
export function setReturnUrl(url: string): void {
  sessionStorage.setItem('kb_return_url', url);
}

/**
 * Get and clear stored return URL
 */
export function popReturnUrl(): string {
  const url = sessionStorage.getItem('kb_return_url');
  sessionStorage.removeItem('kb_return_url');
  return url || '/';
}

/**
 * A v4 UUID for a request or reply's idempotency key. `crypto.randomUUID` is
 * missing outside secure contexts (a help center on plain http) and in older
 * browsers (Safari before 15.4); `crypto.getRandomValues` is not, so the same
 * format is built from it there.
 */
export function newIdempotencyKey(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40; // version 4
  b[8] = (b[8] & 0x3f) | 0x80; // RFC 4122 variant
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
